/* Dýravinir live-follow-up Top 20: small, reversible DOM refinements. */
(() => {
  'use strict';

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('is');

  function normalizeLabels(root = document) {
    const replacements = new Map([
      ['veldu magn', 'Veldu magn'],
      ['setja í körfu', 'Setja í körfu'],
    ]);
    root.querySelectorAll('.form__label, .quantity__label, .quick-add__submit span, .product-form__submit span')
      .forEach((element) => {
        const replacement = replacements.get(clean(element.textContent));
        if (replacement && element.children.length === 0 && element.textContent !== replacement) {
          element.textContent = replacement;
        }
      });
  }

  function exposeCardTitles(root = document) {
    root.querySelectorAll('.card__heading a[href*="/products/"]').forEach((link) => {
      const title = link.textContent.replace(/\s+/g, ' ').trim();
      if (title && !link.hasAttribute('title')) link.setAttribute('title', title);
    });
  }

  const facetPriority = [
    'tegund fóðurs', 'til á lager', 'aldur hunds', 'aldur kattar', 'próteingjafi',
    'án þessara innihaldsefna', 'pakkningastærð', 'vörumerki', 'verð',
    'vöruflokkur', 'prótein %', 'fita %'
  ];

  function labelForFacet(element) {
    const summary = element.querySelector(':scope > summary, :scope > button');
    return clean(summary?.getAttribute('aria-label') || summary?.textContent)
      .replace(/\s*\(\d+ valin sía\)$/, '');
  }

  function reorderFacetGroup(container, selector) {
    if (!container || container.dataset.dvT20Ordered === 'true') return;
    const facets = Array.from(container.querySelectorAll(`:scope > ${selector}`));
    if (facets.length < 2) return;
    facets.sort((a, b) => {
      const ai = facetPriority.indexOf(labelForFacet(a));
      const bi = facetPriority.indexOf(labelForFacet(b));
      return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi);
    });
    facets.forEach((facet) => {
      const label = labelForFacet(facet);
      const index = facetPriority.indexOf(label);
      facet.classList.toggle('dv-t20-facet-primary', index >= 0 && index <= 6);
      facet.classList.toggle('dv-t20-facet-technical', index >= 9);
      container.appendChild(facet);
    });
    container.dataset.dvT20Ordered = 'true';
  }

  function reorderFacets(root = document) {
    root.querySelectorAll('#FacetsWrapperDesktop').forEach((container) => reorderFacetGroup(container, '.facets__disclosure-vertical'));
    root.querySelectorAll('.mobile-facets__main').forEach((container) => reorderFacetGroup(container, '.mobile-facets__details'));
  }

  function enhance(root = document) {
    normalizeLabels(root);
    exposeCardTitles(root);
    reorderFacets(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  document.addEventListener('shopify:section:reorder', () => enhance());

  const main = document.querySelector('#MainContent');
  if (main && 'MutationObserver' in window) {
    new MutationObserver((records) => {
      if (records.some((record) => record.addedNodes.length)) enhance(main);
    }).observe(main, { childList: true, subtree: true });
  }
})();
